<template>
  <div>
    <div v-if="!dataloaded" class="blackbox-loader"></div>

    <div v-if="dataloaded">
      <v-container
        grid-list-xl
        fluid
        class="ma-0 pa-0"
        v-if="packages.length > 0 || userRole == 'superadmin'"
      >
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex xs12>
            <h2 style="display: inline-block;" class="packages-title">
              Hoe kunnen wij {{ userCompanyName }} helpen?
            </h2>

            <div
              v-if="userRole == 'superadmin'"
              style="float: right;"
              class="text-xs-right"
            >
              <v-btn
                class="mx-1"
                @click="newPackageDialog = true"
                rounded
                right
                :color="companySecondaryColor"
                dark
                >Dienst <v-icon right dark>add_circle</v-icon></v-btn
              >
              <v-btn
                class="mx-1"
                @click="newNewsDialog = true"
                rounded
                :color="companyPrimaryColor"
                dark
                >Nieuws <v-icon right dark>add_circle</v-icon></v-btn
              >
            </div>
          </v-flex>
          <v-flex
            d-flex
            v-for="(pillarrrPackage, index) in packages"
            :key="index"
            lg3
            md4
            xs12
          >
            <v-card
              outlined
              class="newsitem-wrapper"
              :class="{ unpublished: !pillarrrPackage.published }"
            >
              <div
                class="newsitem-update-image"
                :style="{ backgroundColor: companySecondaryColor }"
              >
                <div v-if="userRole == 'superadmin'" class="newsitem-edit">
                  <v-btn
                    class="ma-0 pa-0"
                    text
                    icon
                    color="white"
                    @click.stop="editPackage(index)"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </div>
                <div class="newsitem-image-wrapper">
                  <v-img
                    @click="readMorePackage(index)"
                    :src="pillarrrPackage.imageUrl"
                    height="200px"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
              </div>
              <div class="newsitem-content-wrapper package">
                <h3>{{ pillarrrPackage.title }}</h3>
                <!-- <div v-html="newsItem.updateDescription"></div> -->

                <div
                  class="newsitem-content-text"
                  v-html="pillarrrPackage.intro.admin"
                ></div>
                <p
                  class="newsitem-read-more"
                  @click="readMorePackage(index)"
                  :style="{ color: companyPrimaryColor }"
                >
                  Lees meer
                </p>

                <div class="newsitem-footer package">
                  <div
                    v-if="
                      userRole == 'manager' ||
                        userRole == 'admin' ||
                        userRole == 'superadmin'
                    "
                    @click="packagesCTA(index)"
                  >
                    <v-btn
                      block
                      large
                      :color="companyPrimaryColor"
                      dark
                      rounded
                      depressed
                      >{{ pillarrrPackage.cta }}</v-btn
                    >
                  </div>
                </div>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <div class="news-wrapper">
        <v-container grid-list-xl fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 class="my-0 py-0">
              <h2 class="news-title">Nieuws</h2>
            </v-flex>
            <v-flex xs12>
              <div class="news-tags">
                <v-chip
                  class="mx-1"
                  v-for="(chip, index) in chips"
                  :key="index"
                  :color="chip.newColor"
                  @click.stop="selectChip(chip.id)"
                >
                  <v-avatar left :color="chip.newAvatarColor" light>
                    <span v-if="chip.selected" style="color:white;">{{
                      chip.number
                    }}</span>
                    <span v-if="!chip.selected" style="color:#999;">{{
                      chip.number
                    }}</span>
                  </v-avatar>
                  <span v-if="chip.selected" style="color:white;">{{
                    chip.name
                  }}</span>
                  <span v-if="!chip.selected" style="color:#827a89;">{{
                    chip.name
                  }}</span>

                  <v-icon
                    v-if="chip.selected"
                    right
                    color="#fff"
                    style="opacity: 0.5;"
                    >cancel</v-icon
                  >
                  <v-icon v-if="!chip.selected" right color="#b2afb5"
                    >add_circle</v-icon
                  >
                </v-chip>
              </div>
            </v-flex>
            <v-flex md12 v-if="news.length > 0 && newsFiltered.length == 0">
              <div class="no-news-data">
                <p>
                  Klik op de
                  <v-chip>
                    <span style="color:#827a89;">Tags</span>
                    <v-icon right color="#b2afb5">add_circle</v-icon>
                  </v-chip>
                  om het gewenste nieuws weer te geven.
                </p>
              </div>
            </v-flex>

            <v-flex
              d-flex
              v-for="(newsItem, index) in newsFiltered"
              :key="index"
              lg3
              md4
              xs6
            >
              <v-card
                outlind
                class="newsitem-wrapper"
                :class="{ unpublished: !newsItem.published }"
              >
                <div
                  class="newsitem-image-wrapper"
                  @click="readMoreNewsitem(index)"
                >
                  <div v-if="userRole == 'superadmin'" class="newsitem-edit">
                    <v-btn
                      class="ma-0 pa-0"
                      text
                      icon
                      color="white"
                      @click.stop="editNewsitem(index)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </div>

                  <div
                    v-if="newsItem.extra && userRole == 'superadmin'"
                    class="extra-comments"
                  >
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon medium color="white" v-on="on">info</v-icon>
                      </template>
                      <span style="color: #fff;"
                        >Bevat extra informatie voor ontwikkelaar</span
                      >
                    </v-tooltip>
                  </div>

                  <span
                    v-if="newsItem.type == 'update'"
                    class="version-number"
                    >{{ newsItem.version }}</span
                  >

                  <div
                    v-if="newsItem.type == 'update'"
                    class="newsitem-update-image-update-overlay"
                    :style="{ backgroundColor: companySecondaryColor }"
                  ></div>

                  <v-img
                    :src="newsItem.imageUrl"
                    height="200px"
                    class="grey lighten-2"
                  >
                    <template v-slot:placeholder>
                      <v-layout fill-height align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                </div>
                <div class="newsitem-content-wrapper">
                  <h3>{{ newsItem.title }}</h3>
                  <!-- <div v-html="newsItem.updateDescription"></div> -->

                  <div class="newsitem-content-text">
                    {{ newsItem.intro | truncate(150) }}
                  </div>
                  <div class="newsitem-footer">
                    <p
                      class="newsitem-read-more"
                      @click="readMoreNewsitem(index)"
                      :style="{ color: companyPrimaryColor }"
                    >
                      Lees meer
                    </p>
                    <div class="favorite-footer">
                      <span
                        v-if="userRole == 'superadmin'"
                        style="margin: 0 10px 0 0;"
                        @click="showNewsViewers(index)"
                      >
                        <span
                          :style="{ color: $vuetify.theme.themes[theme].text }"
                          >{{ newsItem.views.length }}</span
                        >
                        <v-btn
                          dark
                          text
                          icon
                          :color="$vuetify.theme.themes[theme].text"
                          class="ma-0 pa-0"
                          ><v-icon :color="$vuetify.theme.themes[theme].text"
                            >visibility</v-icon
                          ></v-btn
                        >
                      </span>

                      <span
                        :style="{ color: $vuetify.theme.themes[theme].text }"
                        >{{ newsItem.likes.length }}</span
                      >
                      <v-btn
                        @click="likeNewsItem(index)"
                        v-if="_.indexOf(newsItem.likes, userName) >= 0"
                        dark
                        text
                        icon
                        :color="$vuetify.theme.themes[theme].text"
                        class="ma-0 pa-0"
                        ><v-icon :color="$vuetify.theme.themes[theme].text"
                          >favorite</v-icon
                        ></v-btn
                      >
                      <v-btn
                        @click="likeNewsItem(index)"
                        v-else
                        dark
                        text
                        icon
                        :color="$vuetify.theme.themes[theme].text"
                        class="ma-0 pa-0"
                        ><v-icon :color="$vuetify.theme.themes[theme].text"
                          >favorite_border</v-icon
                        ></v-btn
                      >
                    </div>
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <div
          v-if="maxNewsLoaded == news.length"
          class="text-xs-center"
          style="padding: 20px;"
        >
          <v-btn
            v-if="extradataloaded"
            :color="companyPrimaryColor"
            @click="loadMoreNews()"
            >Meer nieuws laden</v-btn
          >
          <div v-if="!extradataloaded" class="extra-loading-dots"></div>
        </div>
      </div>
    </div>

    <!-- / News Viewers Dialo\ -->
    <v-dialog v-model="newsViewersDialog.show" scrollable max-width="600px">
      <v-card>
        <div
          class="hogans-modal-header"
          v-bind:style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2>
            {{ newsViewersDialog.title }} is bekeken door
            {{ newsViewersDialog.number }} gebruiker<span
              v-if="
                newsViewersDialog.number > 1 || newsViewersDialog.number == 0
              "
              >s</span
            >
          </h2>
          <div
            class="hogans-modal-header-close"
            @click="newsViewersDialog.show = false"
          ></div>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <v-container
            v-if="newsViewersDialog.viewers.length > 0"
            grid-list-xl
            fluid
            class="ma-0 pa-0"
          >
            <v-layout
              row
              wrap
              class="ma-0 pa-0"
              v-for="(viewer, index) in newsViewersDialog.viewers"
              :key="index"
            >
              <v-flex xs4>
                {{ viewer.user }}
              </v-flex>
              <v-flex xs4>
                {{ viewer.companyName }}
              </v-flex>
              <v-flex xs4>
                {{ viewer.dateViewed.seconds | moment("D MMM YYYY - HH:mm") }}u
              </v-flex>
            </v-layout>
          </v-container>
          <div v-else class="text-xs-center">
            Er zijn nog geen gebruikers die dit bericht hebben bekeken.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- \ News Viewers Dialog / -->

    <!-- / Package Viewers Dialo\ -->
    <v-dialog v-model="packageViewersDialog.show" scrollable max-width="600px">
      <v-card>
        <div
          class="hogans-modal-header"
          v-bind:style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2>
            {{ packageViewersDialog.title }} is bekeken door
            {{ packageViewersDialog.number }} gebruiker<span
              v-if="
                packageViewersDialog.number > 1 ||
                  packageViewersDialog.number == 0
              "
              >s</span
            >
          </h2>
          <div
            class="hogans-modal-header-close"
            @click="packageViewersDialog.show = false"
          ></div>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <v-container
            v-if="packageViewersDialog.viewers.length > 0"
            grid-list-xl
            fluid
            class="ma-0 pa-0"
          >
            <v-layout
              row
              wrap
              class="ma-0 pa-0"
              v-for="(viewer, index) in packageViewersDialog.viewers"
              :key="index"
            >
              <v-flex xs4>
                {{ viewer.user }}
              </v-flex>
              <v-flex xs4>
                {{ viewer.companyName }}
              </v-flex>
              <v-flex xs4>
                {{ viewer.dateViewed.seconds | moment("D MMM YYYY - HH:mm") }}u
              </v-flex>
            </v-layout>
          </v-container>
          <div v-else class="text-xs-center">
            Er zijn nog geen gebruikers die dit bericht hebben bekeken.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- \ Package Viewers Dialog / -->

    <!-- / CTA Call Us Dialog \ -->
    <v-dialog v-model="ctaCallUsDialog" scrollable max-width="600px">
      <v-card>
        <div
          class="hogans-modal-header"
          v-bind:style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2>Neem contact op met Hogans Agency</h2>
          <div
            class="hogans-modal-header-close"
            @click="ctaCallUsDialog = false"
          ></div>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <h2>Hartelijk dank voor je interesse.</h2>

          Neem contact op met Hogans Agency om de gewenste dienst zo snel
          mogelijk te activeren. We helpen je graag met extra uitleg en
          informatie.
          <br /><br />
          <strong>Joe van Ettekoven</strong> - 06 44 99 45 29<br />
          <strong>Sven Bakker</strong> - 06 16 28 45 78<br /><br />
          Of mail naar <a href="mailto:info@hogans.nl">info@hogans.nl</a>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- \ CTA Call Us Dialog / -->

    <!-- / CTA Call Us Dialog \ -->
    <v-dialog v-model="ctaCustomDialog.show" scrollable max-width="600px">
      <v-card>
        <div
          class="hogans-modal-header"
          v-bind:style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2>{{ ctaCustomDialog.title }}</h2>
          <div
            class="hogans-modal-header-close"
            @click="ctaCustomDialog.show = false"
          ></div>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <div v-html="ctaCustomDialog.message"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- \ CTA Call Us Dialog / -->

    <!-- / Read More News Dialog \ -->
    <v-dialog v-model="readMoreNewsDialog.show" scrollable max-width="600px">
      <v-card>
        <div
          class="hogans-modal-header"
          v-bind:style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2>{{ readMoreNewsDialog.title }}</h2>
          <div
            class="hogans-modal-header-close"
            @click="readMoreNewsDialog.show = false"
          ></div>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <div class="readmore-intro-header" v-if="userRole == 'superadmin'">
            <span class="readmore-intro-header-date"
              ><strong>Datum: </strong>{{ readMoreNewsDialog.publishDate }}
            </span>
            <span class="readmore-intro-header-author"
              ><strong>Auteur: </strong>{{ readMoreNewsDialog.user }}
            </span>
          </div>
          <div class="readmore-intro">{{ readMoreNewsDialog.intro }}</div>
          <div
            class="readmore-content"
            v-html="readMoreNewsDialog.description"
          ></div>
          <div
            v-if="readMoreNewsDialog.extra && userRole == 'superadmin'"
            class="readmore-content-extra"
          >
            <span class="readmore-extra-title">Interne opmerkingen</span>
            <div
              class="readmore-content"
              v-html="readMoreNewsDialog.extra"
            ></div>
          </div>
          <div v-if="readMoreNewsDialog.author && userRole == 'superadmin'">
            <strong>Update auteur: </strong> {{ readMoreNewsDialog.author }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- \ Read More News Dialog / -->

    <!-- / Read More Package Dialog \ -->
    <v-dialog v-model="readMorePackageDialog.show" scrollable max-width="600px">
      <v-card>
        <div
          class="hogans-modal-header"
          v-bind:style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2>{{ readMorePackageDialog.title }}</h2>
          <div
            class="hogans-modal-header-close"
            @click="readMorePackageDialog.show = false"
          ></div>
        </div>

        <v-divider></v-divider>

        <v-card-text>
          <div
            class="readmore-intro"
            v-if="
              userRole == 'admin' ||
                userRole == 'superadmin' ||
                (!readMorePackageDialog.intro.manager &&
                  readMorePackageDialog.intro.employee)
            "
            v-html="readMorePackageDialog.intro.admin"
          ></div>
          <div
            class="readmore-intro"
            v-if="
              (userRole == 'manager' && readMorePackageDialog.intro.manager) ||
                userRole == 'superadmin' ||
                !readMorePackageDialog.intro.employee
            "
            v-html="readMorePackageDialog.intro.manager"
          ></div>
          <div
            class="readmore-intro"
            v-if="
              (userRole == 'employee' &&
                readMorePackageDialog.intro.employee) ||
                userRole == 'superadmin'
            "
            v-html="readMorePackageDialog.intro.employee"
          ></div>
          <div
            class="readmore-content"
            v-if="
              userRole == 'admin' ||
                userRole == 'superadmin' ||
                (!readMorePackageDialog.description.manager &&
                  readMorePackageDialog.description.employee)
            "
            v-html="readMorePackageDialog.description.admin"
          ></div>
          <div
            class="readmore-content"
            v-if="
              (userRole == 'manager' &&
                readMorePackageDialog.description.manager) ||
                userRole == 'superadmin' ||
                !readMorePackageDialog.description.employee
            "
            v-html="readMorePackageDialog.description.manager"
          ></div>
          <div
            class="readmore-content"
            v-if="
              (userRole == 'employee' &&
                readMorePackageDialog.description.employee) ||
                userRole == 'superadmin'
            "
            v-html="readMorePackageDialog.description.employee"
          ></div>

          <div
            class="readmore-price"
            v-if="userRole == 'admin' || userRole == 'superadmin'"
          >
            <strong>Prijs: </strong>{{ readMorePackageDialog.price }}
          </div>
          <div class="readmore-price" v-if="userRole == 'superadmin'">
            <span
              style="margin: 0 10px 0 0;"
              @click="showPackageViewers(index)"
            >
              {{ readMorePackageDialog.viewsNumber }}
              <v-btn dark text icon color="black" class="ma-0 pa-0"
                ><v-icon>visibility</v-icon></v-btn
              >
            </span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="hogans-modal-footer clear">
            <v-btn
              class="modal-button-cancel"
              outline
              depressed
              color="#8B93A6"
              @click="readMorePackageDialog.show = false"
              >Annuleren</v-btn
            >
            <div
              v-if="
                userRole == 'manager' ||
                  userRole == 'admin' ||
                  userRole == 'superadmin'
              "
              class="package-button-wrapper"
              @click="packagesCTA(readMorePackageDialog.index)"
            >
              <div
                v-if="readMorePackageDialog.action"
                class="package-button-action"
              >
                {{ readMorePackageDialog.actionDescription }}
              </div>
              <div
                class="package-button"
                :style="{ backgroundColor: companySecondaryColor }"
              >
                {{ readMorePackageDialog.cta }}
                <div class="package-button-icon">
                  <v-icon :color="companyPrimaryColor">shopping_cart</v-icon>
                </div>
              </div>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Read More Package Dialog / -->

    <!-- / New News Dialog \ -->
    <v-dialog v-model="newNewsDialog" scrollable max-width="600px">
      <add-news-form
        :versions="versions"
        @newNewsDialogChange="newNewsDialog = $event"
        @updateData="updateNews()"
      ></add-news-form>
    </v-dialog>
    <!-- \ New News Dialog / -->

    <!-- / New Package Dialog \ -->
    <v-dialog v-model="newPackageDialog" scrollable max-width="600px">
      <add-package-form
        @newPackageDialogChange="newPackageDialog = $event"
        @updateData="updatePackages()"
      ></add-package-form>
    </v-dialog>
    <!-- \ New Package Dialog / -->

    <!-- / Edit News Dialog \ -->
    <v-dialog v-model="editNewsDialog" scrollable max-width="600px">
      <edit-news-form
        :versions="versions"
        :selectedNewsItem="selectedNewsItem"
        :selectedNewsItemOriginal="selectedNewsItemOriginal"
        @editNewsDialogChange="editNewsDialog = $event"
        @updateData="updateNews()"
      ></edit-news-form>
    </v-dialog>
    <!-- \ Edit News Dialog / -->

    <!-- / Edit Package Dialog \ -->
    <v-dialog v-model="editPackageDialog" scrollable max-width="600px">
      <edit-package-form
        :selectedPackage="selectedPackage"
        :selectedPackageOriginal="selectedPackageOriginal"
        @editPackageDialogChange="editPackageDialog = $event"
        @updateData="updatePackages()"
      ></edit-package-form>
    </v-dialog>
    <!-- \ Edit Package Dialog / -->
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import db from "../firebase/init";
import AddNewsForm from "../components/modals/AddNewsForm.vue";
import AddPackageForm from "../components/modals/AddPackageForm.vue";
import EditNewsForm from "../components/modals/EditNewsForm.vue";
import EditPackageForm from "../components/modals/EditPackageForm.vue";
import moment from "moment";

export default {
  name: "Home",
  components: {
    "add-news-form": AddNewsForm,
    "add-package-form": AddPackageForm,
    "edit-news-form": EditNewsForm,
    "edit-package-form": EditPackageForm,
  },

  data: () => ({
    newNewsDialog: false,
    editNewsDialog: false,
    newPackageDialog: false,
    editPackageDialog: false,
    ctaCallUsDialog: false,
    ctaCustomDialog: {
      show: false,
      title: null,
      message: null,
    },
    newsViewersDialog: {
      show: false,
      title: null,
      number: null,
      viewers: 0,
    },
    packageViewersDialog: {
      show: false,
      title: null,
      number: null,
      viewers: 0,
    },
    readMoreNewsDialog: {
      show: false,
      title: null,
      intro: null,
      description: null,
      extra: null,
      author: null,
      user: null,
      publishDate: null,
    },
    readMorePackageDialog: {
      index: null,
      show: false,
      title: null,
      intro: {
        admin: null,
        manager: null,
        employee: null,
      },
      description: {
        admin: null,
        manager: null,
        employee: null,
      },
      price: null,
      extra: null,
      author: null,
      user: null,
      publishDate: null,
      viewsNumber: 0,
      views: [],
    },
    selectedNewsItem: {},
    selectedNewsItemOriginal: {},
    selectedPackage: {
      intro: {},
      description: {},
    },
    selectedPackageOriginal: {
      intro: {},
      description: {},
    },
    newsContinueAt: {},
    maxNewsLoaded: 0,
    dataloaded: false,
    extradataloaded: true,
    news: [],
    packages: [],
    versions: [],
    items: [
      {
        name: "Nieuws",
        id: "news",
        selected: true,
        color: "#E79760",
        avatarColor: "#EEB690",
        number: 0,
      },
      {
        name: "Tips",
        id: "tip",
        selected: true,
        color: "#83C0EC",
        avatarColor: "#A7D2F1",
        number: 0,
      },
      {
        name: "Succesverhalen",
        id: "casestudie",
        selected: true,
        color: "#F39488",
        avatarColor: "#F6B3AB",
        number: 0,
      },
      {
        name: "Acties",
        id: "action",
        selected: true,
        color: "#F8DD65",
        avatarColor: "#FAE792",
        number: 0,
      },
      {
        name: "Updates",
        id: "update",
        selected: true,
        color: "#72D9C4",
        avatarColor: "#9CE4D5",
        number: 0,
      },
    ],
  }),

  created() {
    this.loadNews();
    this.loadPackages();
  },

  filters: {
    truncate: function(value, limit) {
      // Maximaal aantal characters laten zien
      if (value.length > limit) {
        value = value.substring(0, limit - 3) + "...";
      }
      return value;
    },
  },

  methods: {
    editNewsitem(index) {
      // Nieuws item bewerken. Juiste data in props zetten.
      this.editNewsDialog = true;
      this.selectedNewsItem = _.cloneDeep(this.newsFiltered[index]);
      this.selectedNewsItemOriginal = _.cloneDeep(this.selectedNewsItem);
    },

    editPackage(index) {
      // Nieuws item bewerken. Juiste data in props zetten.
      this.editPackageDialog = true;
      this.selectedPackage = _.cloneDeep(this.packages[index]);
      this.selectedPackageOriginal = _.cloneDeep(this.selectedPackage);
    },

    showNewsViewers(index) {
      this.newsViewersDialog.title = this.newsFiltered[index].title;
      this.newsViewersDialog.viewers = this.newsFiltered[index].views;
      this.newsViewersDialog.number = this.newsFiltered[index].views.length;
      this.newsViewersDialog.show = true;
    },

    showPackageViewers(index) {
      this.packageViewersDialog.title = this.readMorePackageDialog.title;
      this.packageViewersDialog.viewers = this.readMorePackageDialog.views;
      this.packageViewersDialog.number = this.readMorePackageDialog.viewsNumber;
      this.packageViewersDialog.show = true;
    },

    packagesCTA(index) {
      this.readMorePackageDialog.show = false;
      if (this.packages[index].ctaAction == "callUs") {
        this.ctaCallUsDialog = true;
      } else {
        this.ctaCustomDialog.title = this.packages[index].cta;
        this.ctaCustomDialog.message = this.packages[
          index
        ].ctaActionDescription;
        this.ctaCustomDialog.show = true;
      }
    },

    updateNews() {
      // Data updaten na toevoegen of wijzigen van nieuws
      this.selectedNewsItem = {};
      this.selectedNewsItemOriginal = {};
      this.loadNews();
    },

    updatePackages() {
      // Data updaten na toevoegen of wijzigen van nieuws
      this.selectedPackageItem = {
        intro: {},
        description: {},
      };
      this.selectedPackageItemOriginal = {
        intro: {},
        description: {},
      };
      this.loadPackages();
    },

    readMorePackage(index) {
      // Juiste data laden om popup met meer packageinfo weer te geven
      // this.readMorePackageDialog = _.cloneDeep(this.packages[index])
      this.readMorePackageDialog.index = index;
      this.readMorePackageDialog.title = this.packages[index].title;
      this.readMorePackageDialog.intro = this.packages[index].intro;
      this.readMorePackageDialog.description = this.packages[index].description;
      this.readMorePackageDialog.cta = this.packages[index].cta;
      this.readMorePackageDialog.price = this.packages[index].price;
      this.readMorePackageDialog.viewsNumber = this.packages[
        index
      ].views.length;
      this.readMorePackageDialog.views = this.packages[index].views;

      this.readMorePackageDialog.show = true;

      let userName = this.userName;
      let currentUser = {
        user: this.userFirstName + " " + this.userLastName,
        company: this.userCompany,
        companyName: this.userCompanyName,
        userName: userName,
        dateViewed: new Date(),
      };

      let userIndex = _.findIndex(this.packages[index].views, function(o) {
        return o.userName == userName;
      });

      if (userIndex < 0) {
        this.packages[index].views.push(currentUser);
        let viewsArray = {
          views: this.packages[index].views,
        };
        db.collection("packages")
          .doc(this.packages[index].id)
          .update(viewsArray);
      }
    },

    readMoreNewsitem(index) {
      // Juiste data laden om popup met meer nieuws weer te geven
      this.readMoreNewsDialog.title = this.newsFiltered[index].title;
      this.readMoreNewsDialog.intro = this.newsFiltered[index].intro;
      this.readMoreNewsDialog.description = this.newsFiltered[
        index
      ].description;
      this.readMoreNewsDialog.extra = this.newsFiltered[index].extra;
      this.readMoreNewsDialog.user = this.newsFiltered[index].user;
      this.readMoreNewsDialog.publishDate = moment(
        this.newsFiltered[index].publishDate,
      ).format("D MMMM YYYY");

      let userName = this.userName;
      let currentUser = {
        user: this.userFirstName + " " + this.userLastName,
        company: this.userCompany,
        companyName: this.userCompanyName,
        userName: userName,
        dateViewed: new Date(),
      };

      let userIndex = _.findIndex(this.newsFiltered[index].views, function(o) {
        return o.userName == userName;
      });

      if (userIndex < 0) {
        this.newsFiltered[index].views.push(currentUser);
        let viewsArray = {
          views: this.newsFiltered[index].views,
        };
        db.collection("news")
          .doc(this.newsFiltered[index].id)
          .update(viewsArray);
      }

      if (this.newsFiltered[index].type == "update") {
        this.readMoreNewsDialog.author = this.newsFiltered[index].updateAuthor;
      } else {
        this.readMoreNewsDialog.author = null;
      }
      this.readMoreNewsDialog.show = true;
    },

    likeNewsItem(index) {
      let userIndex = _.indexOf(this.newsFiltered[index].likes, this.userName);
      console.log(userIndex);
      if (userIndex >= 0) {
        // Al wel geliked
        console.log("Al geliked");
        this.newsFiltered[index].likes.splice(userIndex, 1);
        let likesArray = {
          likes: this.newsFiltered[index].likes,
        };
        db.collection("news")
          .doc(this.newsFiltered[index].id)
          .update(likesArray);
      } else {
        // Nog niet geliked
        console.log("Nog niet geliked");
        this.newsFiltered[index].likes.push(this.userName);
        let likesArray = {
          likes: this.newsFiltered[index].likes,
        };
        db.collection("news")
          .doc(this.newsFiltered[index].id)
          .update(likesArray);
      }
    },

    loadPackages() {
      // Packages binnenladen
      this.dataloaded = false;
      this.packages = [];
      db.collection("packages")
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            if (
              (doc.data().published &&
                !_.includes(this.companyPackages, doc.data().name)) ||
              this.userRole == "superadmin"
            ) {
              if (
                doc.data().showTo == "all" ||
                doc.data().showTo == this.companyType ||
                this.userRole == "superadmin"
              ) {
                let pillarPackage = doc.data();
                pillarPackage.id = doc.id;
                this.packages.push(pillarPackage);
              }
            }
          });
        })
        .then(() => {
          this.dataloaded = true;
        })
        .catch((error) => {
          console.error("Error bij laden packages: ", error);
        });
    },

    loadNews() {
      // Nieuws binnenladen
      this.dataloaded = false;
      this.news = [];
      this.versions = [];
      let updateCounter = 0;
      db.collection("news")
        .orderBy("publishDate", "desc")
        .limit(50)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            if (
              doc.data().published == true ||
              (doc.data().published == false && this.userRole == "superadmin")
            ) {
              if (
                doc.data().showTo == "all" ||
                doc.data().showTo == this.companyType ||
                this.userRole == "superadmin"
              ) {
                let news = doc.data();
                news.id = doc.id;
                news.publishDate = moment
                  .unix(doc.data().publishDate.seconds)
                  .format("YYYY-MM-DD");
                this.news.push(news);
                if (doc.data().type == "update") {
                  // Software versies binnenladen
                  updateCounter++;
                  let softwareUpdate = {};
                  softwareUpdate.version = doc.data().version;
                  softwareUpdate.author = doc.data().updateAuthor;
                  softwareUpdate.date = moment
                    .unix(doc.data().publishDate.seconds)
                    .format("D MMMM YYYY");
                  // Alleen de laatste 5 versies binnenladen
                  if (updateCounter < 6) {
                    this.versions.push(softwareUpdate);
                  }
                }
                this.newsContinueAt = snap.docs[snap.docs.length - 1];
              }
            }
          });
        })
        .then(() => {
          // Verschillende typen tellen (Op basis hiervan worden de chips weergegeven)
          this.items.map((item) => {
            item.number = 0;
          });

          let items = this.items;

          this.news.map((newsItem) => {
            if (newsItem.type == "news") {
              this.items[_.findIndex(items, { id: "news" })].number++;
            } else if (newsItem.type == "tip") {
              this.items[_.findIndex(items, { id: "tip" })].number++;
            } else if (newsItem.type == "casestudies") {
              this.items[_.findIndex(items, { id: "casestudie" })].number++;
            } else if (newsItem.type == "actions") {
              this.items[_.findIndex(items, { id: "action" })].number++;
            } else if (newsItem.type == "update") {
              this.items[_.findIndex(items, { id: "update" })].number++;
            }
          });
        })
        .then(() => {
          this.maxNewsLoaded = 50;
          this.dataloaded = true;
        })
        .catch((error) => {
          console.error("Error bij laden nieuws: ", error);
        });
    },

    loadMoreNews() {
      this.extradataloaded = false;
      let updateCounter = this.versions.length;
      db.collection("news")
        .orderBy("publishDate", "desc")
        .startAfter(this.newsContinueAt)
        .limit(50)
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            if (
              doc.data().published == true ||
              (doc.data().published == false && this.userRole == "superadmin")
            ) {
              let news = doc.data();
              news.id = doc.id;
              news.publishDate = moment
                .unix(doc.data().publishDate.seconds)
                .format("YYYY-MM-DD");
              this.news.push(news);
              if (doc.data().type == "update") {
                // Software versies binnenladen
                updateCounter++;
                let softwareUpdate = {};
                softwareUpdate.version = doc.data().version;
                softwareUpdate.author = doc.data().updateAuthor;
                softwareUpdate.date = moment
                  .unix(doc.data().publishDate.seconds)
                  .format("D MMMM YYYY");
                // Alleen de laatste 5 versies binnenladen
                if (updateCounter < 6) {
                  this.versions.push(softwareUpdate);
                }
              }
              this.newsContinueAt = snap.docs[snap.docs.length - 1];
            }
          });
        })
        .then(() => {
          // Verschillende typen tellen (Op basis hiervan worden de chips weergegeven)
          let items = this.items;
          this.news.map((newsItem) => {
            if (newsItem.type == "news") {
              this.items[_.findIndex(items, { id: "news" })].number++;
            } else if (newsItem.type == "tips") {
              this.items[_.findIndex(items, { id: "tip" })].number++;
            } else if (newsItem.type == "casestudies") {
              this.items[_.findIndex(items, { id: "casestudie" })].number++;
            } else if (newsItem.type == "actions") {
              this.items[_.findIndex(items, { id: "action" })].number++;
            } else if (newsItem.type == "update") {
              this.items[_.findIndex(items, { id: "update" })].number++;
            }
          });
        })
        .then(() => {
          let maxNewsLoaded = this.maxNewsLoaded + 50;
          this.maxNewsLoaded = maxNewsLoaded;
          this.extradataloaded = true;
        })
        .catch((error) => {
          console.error("Error bij laden extra nieuws: ", error);
        });
    },

    selectChip(chipId) {
      // Chip aan/uit zetten
      this.items.map((item) => {
        if (chipId == item.id) {
          if (item.selected == true) {
            item.selected = false;
          } else if (item.selected == false) {
            item.selected = true;
          }
        }
      });
    },
  },

  computed: {
    companyPackages() {
      return this.$store.state.companyPackages;
    },

    companyNarrowcasting() {
      if (_.includes(this.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },

    newsFiltered() {
      // Alleen nieuws laten zien waarvan de chip aanstaat. (Je kan alleen ongepubliceerd nieuws zien als superadmin)
      let newsItems = [];
      this.news.map((newsItem) => {
        if (
          this.items[_.findIndex(this.items, { id: newsItem.type })].selected
        ) {
          newsItems.push(newsItem);
        }
      });
      return newsItems;
    },

    chips() {
      // Chips juiste kleur en eigenschappen geven als hij aan/uit staat
      let chipsItems = [];
      this.items.forEach((item) => {
        if (item.number > 0) {
          if (item.selected == false) {
            item.newColor = "#e0e0e0";
            item.newAvatarColor = "#f1f1f1";
          } else {
            item.newColor = item.color;
            item.newAvatarColor = item.avatarColor;
          }
          chipsItems.push(item);
        }
      });
      return chipsItems;
    },

    companyType() {
      return this.$store.state.companyType;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userName() {
      return this.$store.state.userName;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userCompanyName() {
      return this.$store.state.userCompanyName;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
  },
};
</script>

<style scoped>
.v-chip:focus:not(.v-chip--selected):after {
  display: none;
}

.packages-title,
.news-title {
  font-family: "Sofia Pro", san-serif;
  font-weight: 400;
  font-size: 34px;
  color: var(--v-text-base);
}

.newsitem-wrapper.unpublished {
  opacity: 0.3;
}

.newsitem-wrapper h3 {
  font-family: "Sofia Pro", san-serif;
  font-weight: 600;
  width: 100%;
  font-size: 18px;
  color: var(--v-text-base);
  line-height: 21px;
  margin: 0 0 20px 0;
}

.newsitem-content-wrapper {
  font-family: "Sofia Pro", san-serif;
  font-weight: 300;
  font-size: 15px;
  padding: 15px 15px 60px 15px;
  color: var(--v-text-base);
  line-height: 20px;
}

.newsitem-content-wrapper.package {
  padding: 15px 15px 60px 15px;
}

.newsitem-image-wrapper {
  position: relative;
  width: 100%;
  height: 200px;
  cursor: pointer;
  text-decoration: underline;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.newsitem-content-text,
.newsitem-content-text p {
  color: var(--v-text-base) !important;
}

.newsitem-footer {
  position: absolute;
  bottom: 0;
  height: 50px;
  left: 0;
  padding: 0 10px;
  width: 100%;
}

.newsitem-footer.package {
  height: 60px;
}

.favorite-footer {
  position: absolute;
  right: 15px;
  top: 0;
}

.newsitem-read-more {
  padding: 8px 0 0 0;
  font-family: "Sofia Pro", san-serif;
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.4px;
  cursor: pointer;
  text-decoration: underline;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.newsitem-read-more:hover {
  cursor: pointer;
  opacity: 0.8;
}

.newsitem-edit {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 8;
  cursor: default;
}

.extra-comments {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 70;
  cursor: default;
}

.newsitem-image-wrapper .version-number {
  width: 100%;
  top: 0;
  left: 0;
  position: absolute;
  color: white;
  width: 100%;
  font-size: 68px;
  margin: 50px 0;
  text-align: center;
  display: inline-block;
  z-index: 8;
}

.readmore-intro-header {
  padding: 0 0 15px 0;
}
.readmore-intro-header-date,
.readmore-intro-header-author {
  display: block;
  padding: 0 0 3px 0;
}

.readmore-intro {
  padding: 0 0 15px 0;
}

.readmore-content {
  margin: 0 0 15px 0;
}

.readmore-content-extra {
  padding: 8px;
  background-color: #eee;
  margin: 0 0 15px 0;
}

.package-button-icon .v-icon {
  margin: 0;
}

.no-news-data {
  width: 500px;
  margin: 150px auto;
}

.no-news-data p {
  text-align: center;
  font-size: 16px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.newsitem-update-image-update {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
}

.newsitem-update-image-update-overlay {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.85;
  z-index: 7;
}

.package-button-wrapper {
  position: absolute;
  right: 15px;
  bottom: 15px;
  cursor: pointer;
  text-decoration: underline;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-decoration: none;
}

.package-button-wrapper:hover {
  opacity: 0.85;
}

.package-button {
  position: relative;
  padding: 10px 50px 14px 15px;
  border-radius: 100px;
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  letter-spacing: 0.4px;
  text-decoration: none;
  cursor: pointer;
}

.package-button:hover {
  cursor: pointer;
}

.package-button-icon {
  position: absolute;
  height: 36px;
  width: 36px;
  right: 4px;
  top: 4px;
  background: white;
  border-radius: 50px;
  padding: 7px;
  cursor: pointer;
}

.package-button-action {
  background-color: #ffcb34;
  font-family: "Sofia Pro", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  display: inline-block;
  margin: 0 0 0 30px;
  padding: 4px 8px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  text-decoration: none;
  cursor: pointer;
}

/*
<div class="package-button-wrapper">
  <div v-if="pillarrrPackage.action" class="package-button-action">{{ pillarrrPackage.actionDescription}} </div>
  <div class="package-button">{{ pillarrrPackage.cta }}</div>
</div>

*/
</style>
